import * as React from "react";
import { cn } from "../../lib/utils.jsx";

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(({ className, ...props }, ref) => (
  <label ref={ref} className={cn("text-sm font-medium text-gray-200", className)} {...props} />
));
Label.displayName = "Label";

export default Label;

